import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Silence diagnostic logging on deployed builds. console.warn / console.error are
// left intact so real failures are still visible in support reports.
if (!environment.enableConsoleLogs) {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.table = () => {};
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
